import { useState, useEffect } from 'react';
import { storedFileSrc, resolveTenantSlug, tokens } from '../lib/api';

/**
 * An <img> for endpoints that require the bearer token. A plain <img src> can't send the
 * Authorization header, and news media is auth-gated — so we fetch the bytes with the token and show
 * them as an object URL. Used for feed photos and gallery images.
 */
export function AuthImage({ url, alt, style, className }: { url: string; alt?: string; style?: React.CSSProperties; className?: string }) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objUrl: string | null = null;
    (async () => {
      try {
        const slug = resolveTenantSlug();
        // ⚠ storedFileSrc: an absolute URL must not be prefixed. Same trap as the crest.
        const res = await fetch(storedFileSrc(url)!, {
          headers: {
            ...(slug ? { 'X-Tenant': slug } : {}),
            ...(tokens.access() ? { Authorization: `Bearer ${tokens.access()}` } : {}),
          },
        });
        if (!res.ok) { setFailed(true); return; }
        const blob = await res.blob();
        if (revoked) return;
        objUrl = URL.createObjectURL(blob);
        setSrc(objUrl);
      } catch { setFailed(true); }
    })();
    return () => { revoked = true; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [url]);

  if (failed) return null;
  if (!src) return <div className={className} style={{ ...style, background: 'var(--surface-2,#f0f0ee)' }} />;
  return <img src={src} alt={alt ?? ''} className={className} style={style} />;
}
